module.exports = __webpack_public_path__ + "img/feature_buy_en.ccd6f5c7.png";